import client from './graphQlClient';
import {
    SEARCH_CARGOES,
    GET_CARGOES_WITH_PARENTS_BY_IDS,
    GET_CARGOES_BY_IDS,
} from './queries/CargoQueries';

export class CargoApi {
    static search = (search, groupId, cancelToken) => {
        return new Promise((resolve, reject) => {
            client()
                .query({
                    query: SEARCH_CARGOES,
                    fetchPolicy: 'no-cache',
                    variables: {
                        search,
                        groupId,
                    },
                })
                .then((result) => {
                    resolve(result.data.cargoes);
                });
            cancelToken.promise.then((reason) => {
                reject(reason);
            });
        });
    };

    static getByIds = (ids) =>
        client()
            .query({
                query: GET_CARGOES_BY_IDS,
                fetchPolicy: 'no-cache',
                variables: {
                    ids,
                },
            })
            .then((result) => result.data.cargoesByIds);

    static getWithParentsByIds = (ids) =>
        client()
            .query({
                query: GET_CARGOES_WITH_PARENTS_BY_IDS,
                fetchPolicy: 'no-cache',
                variables: {
                    ids,
                },
            })
            .then((result) => result.data.cargoesWithParentsByIds);
}
